export default {
  routes: [
    {
      name: 'access',
      path: '/admin/access',
      component: () => import('./views/TheAccessPage.vue'),

    },
  ]
}
